import { AdInactiveReason, IAdvertisementProgress, PropertyAdState } from '@/models/propertyProgress.model';

/** Publicly visible on FINN — with or without the sold badge. */
const visibleStates: PropertyAdState[] = [PropertyAdState.LIVE, PropertyAdState.LIVE_SOLD];

export const isAdPublished = (advertisement?: IAdvertisementProgress) => {
  if (!advertisement) return false;

  if (visibleStates.includes(advertisement.state)) return true;

  return (
    advertisement.state === PropertyAdState.INACTIVE &&
    advertisement.inactive_reason !== AdInactiveReason.NEVER_PUBLISHED
  );
};

/** Only a publicly visible listing can be stopped. */
export const canStopAd = (advertisement?: IAdvertisementProgress) =>
  !!advertisement && visibleStates.includes(advertisement.state);

export const isAdOperationInProgress = (advertisement?: IAdvertisementProgress) => !!advertisement?.in_progress;
